module.exports = __webpack_public_path__ + "static/media/VIP_Hour_Tile_1star@3x.7eee4918.png";